import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./App.tsx";
import { queryConfig } from "./api/react-query.config.ts";
import ErrorDialog from "./components/error-dialogue/ErrorDialog.tsx";
import { store } from "./store";

export const AppProviders = () => {
	// State
	const [queryClient] = useState(() => {
		return new QueryClient({
			defaultOptions: queryConfig,
		});
	});

	return (
		<Provider store={store}>
			<HelmetProvider>
				<BrowserRouter>
					<QueryClientProvider client={queryClient}>
						<ErrorDialog />
						<App />
					</QueryClientProvider>
				</BrowserRouter>
			</HelmetProvider>
		</Provider>
	);
};
